module.exports = __webpack_public_path__ + "img/BatAgriToitR.98ea41e6.png";